module.exports = __webpack_public_path__ + "static/media/loading.4e2365cf.gif";